export const DestinationTypeIDEnum = {
  PatientPortal: 0,
  UploadPhotos: 1,
  Payment: 2,
  Schedule: 3,
  Reschedule: 4,
  SupportPatientPortal: 5,
};
